module.exports = __webpack_public_path__ + "52c71e3d25f6b12d0ae602be32b173e0.jpg";